import { useCallback, useEffect, useState } from 'react'
import type { CompetitionStandingsData } from './types'

/**
 * The competition scoreboard for one gender category. Refetched rather than
 * cached, because a competitor logging a route expects to see the board move.
 */
export function useCompetitionStandings(
  competitionId: string | undefined,
  /** 'all', or one of this competition's category ids. */
  category: string,
  apiUrl: string,
  getAccessTokenSilently: () => Promise<string>,
) {
  const [data, setData] = useState<CompetitionStandingsData | null>(null)
  const [loading, setLoading] = useState(true)

  const reload = useCallback(async () => {
    if (!competitionId) return
    setLoading(true)
    try {
      const token = await getAccessTokenSilently()
      const res = await fetch(
        `${apiUrl}/my-competitions/${competitionId}/standings?category=${category}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      if (res.ok) setData((await res.json()) as CompetitionStandingsData)
    } finally {
      setLoading(false)
    }
  }, [competitionId, category, apiUrl, getAccessTokenSilently])

  useEffect(() => {
    void reload()
  }, [reload])

  return { data, loading, reload }
}
